import * as _ from 'lodash';
import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

const ROW_HEIGHT = 25;
const ROW_SPACING = 10;

/**
 * Total height of the SVG is:
 * h = (ROW_HEIGHT + ROW_SPACING) * rowCount
 */
const getTotalHeight = (rowCount: number): `${string}px` =>
  `${(ROW_HEIGHT + ROW_SPACING) * rowCount}px`;

type Props = {
  rowCount?: number;
};

/**
 * DetailsPanelLoading is the loading state for the DetailsPanel.
 *
 * TODO(dave): this is actually dying to be made into a generic
 */
const DetailsPanelLoading: VoidFunctionComponent<Props> = ({ rowCount = 6 }) => (
  <ContentLoader width="100%" height={getTotalHeight(rowCount)}>
    {
      _.range(0, rowCount).map(rowIndex => (
        <rect
          //  Horizontal position of the row
          x="0"
          //  These are border-radius props
          rx="3"
          ry="3"
          //  We want the row to fill the SVG
          width="100%"
          //  Later we might make this configurable, but fine for now.
          height={ROW_HEIGHT}
          y={rowIndex * (ROW_HEIGHT + ROW_SPACING)}
        />
      ))
    }
  </ContentLoader>
);

export default DetailsPanelLoading;
